import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";





const helpers = {







  circleButton: function circleButtonHelper(jcr) {
    if (!jcr) { throw new Error('No circle button JCR objects provided to helper-circle-button.'); }


    const icon = jcr.icon ? jcr.icon : '';
    const label = jcr.label ? jcr.label : '';
    const userClasses = jcr.classes ? jcr.classes : [];
    const attributes = jcr.attributes ? jcr.attributes : {};
    const role = jcr.role ? jcr.role : 'button';
    const adaText = jcr.adaText ? jcr.adaText : '';

    let allClasses = '';
    userClasses.forEach((userClass) => {
      allClasses += `${userClass} `
    });

    const attributeKeys = (jcr.attributes) ? Object.keys(jcr.attributes) : [];
    let allAttributes = '';
    attributeKeys.forEach((key) => {
      (key === 'disabled' && attributes['disabled'] === true) ?
        allAttributes += ` disabled `:  allAttributes += ` ${key}="${attributes[key]}"`;
    });

    let circleButton = `
      <button
        ${jcr.vueOptionsStr || ''}
        class="spa-circle-btn-wrapper ${allClasses}"
        ${allAttributes}
        role=${role}
      >
        <span class="spa-circle-btn" aria-hidden="true">
          <span class="spa-icon circle-icon-${icon} spa-circle-btn-icon"></span>
        </span>
        <span class="spa-circle-btn-label">${label}
          <span class="spa-ada-text ada-hidden">${adaText}</span>
        </span>
      </button>
    `;

    return new Handlebars.SafeString(circleButton);
  }
};





class circleButtonHelper {






  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }
}

module.exports = circleButtonHelper;
